import React from 'react';

import {
  Icon,
} from 'web-components';

import * as S from './styled';
import { ButtonProps } from './styled';

/**
 * Button
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref) => {
  const {
    appearance,
    children,
    className,
    onClick,
    spacing,
    isDisabled,
    icon,
    iconSize,
    iconColor,
    isSelected,
    isLoading,
    inline,
    type,
  } = props;
  return (
    <S.Button
      {...props}
      ref={ref}
      type={type}
      spacing={spacing}
      className={className}
      appearance={appearance}
      onClick={onClick}
      inline={inline}
      isSelected={isSelected}
      disabled={isDisabled}
    >
      {!!icon && (
        <Icon
          type={icon}
          size={iconSize}
          color={iconColor}
        />
      )}
      {children && (<span>{children}</span>)}
      {isLoading && (
        <Icon
          type="fa fa-spinner fa-spin"
          color="inherit"
        />
      )}
    </S.Button>
  );
});

Button.defaultProps = {
  isDisabled: false,
  isSelected: false,
  isLoading: false,
  navLink: false,
  ghost: false,
  children: null,
  className: '',
  inline: false,
  type: 'button',
  icon: '',
  width: 'auto',
  iconSize: 'default',
  iconColor: 'inherit',
  spacing: 'default',
  appearance: 'default',
  onClick: () => {},
};

export default Button;
